import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Output, type OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogActions, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { LayoutService } from 'src/app/service/layout.service';

@Component({
  selector: 'app-add-service-repeated',
  standalone: true,
  imports: [
    CommonModule,

    TranslateModule,

    MatDialogTitle,
    MatIconModule,
    MatDialogActions,
    MatButtonModule
  ],
  templateUrl: './add-service-repeated.component.html',
  styleUrl: './add-service-repeated.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddServiceRepeatedComponent implements OnInit {

  @Output() update : number;

  sub: Subscription;

  readonly OPERATION_CANCEL = 0;
  readonly OPERATION_SEPARATE = 1;

  constructor(
    // @Inject(MAT_DIALOG_DATA) public data: {
    //   text: string,
    //   value: number
    // },
    public layout: LayoutService,
    public dialogRef: MatDialogRef<AddServiceRepeatedComponent>
  ) {
  }

  ngOnInit() {
  }

  cancel() {;
    this.dialogRef.close(this.OPERATION_CANCEL)
  }

  onSeparate() {
    this.dialogRef.close(this.OPERATION_SEPARATE);
  }
}
